module.exports = __webpack_public_path__ + "img/shy.ac4c5cbe.jpg";